import { BrandBand, Icon, PageHeader, Tabs, TabsPanel } from '@salesforce/design-system-react';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getNumbersWithDecimalPlaces } from '../../../utilities/money';
import { resolveAddress } from '../../../services/contactAndContract';
import { defiTransactionsSelector, getTransaction } from '../../../store/defi/transactionsSlice';
import TransactionDetailsTab from '../components/transactionDetails';
import { getDateTimeFromTimestamp } from '../../../utilities/datetime';
import Spinner from '../../../components/Spinner';
import Notes from './defi/Notes';

export default function TransactionDetails() {
  const location = useLocation();
  const dispatch = useDispatch();
  const { loading, transaction } = useSelector(defiTransactionsSelector);
  const [item, setItem] = useState();
  const [id, setId] = useState('');

  useEffect(() => {
    /**
     * URI will be in the format /defi/:account/path
     */
    const path = location.pathname.split('/').filter((path) => path !== '');
    //This will set the current account id in the state
    setId(path[1]);
  }, [location]);

  useEffect(() => {
    if (!id) return;
    dispatch(getTransaction(id));
  }, [id, dispatch]);

  useEffect(() => {
    if (transaction) setItem(transaction);
  }, [transaction]);

  const details = [
    {
      label: 'Date',
      content: (
        <span style={{ fontWeight: '700' }}>{getDateTimeFromTimestamp(item?.time_at * 1000)}</span>
      ),
      truncate: true,
    },
    {
      label: 'Account',
      content: (
        <p style={{ fontWeight: '700' }} className="slds-truncate">
          {item && resolveAddress(item?.account).name}
        </p>
      ),
    },
    {
      label: 'TX Type',
      content: (
        <span style={{ fontWeight: '700' }}>
          {item && item.cate_id === 'receive' && 'Receive Token'}
          {item && item.cate_id === 'send' && 'Send Token'}
          {item && item.cate_id === 'approve' && 'Approve Token'}
          {item && !item.cate_id && (
            // <>{Object.keys(item.tx).length === 0 ? item.tx.name : 'Others'}</>
            <>{item?.tx?.name ? item.tx.name : 'Others'}</>
          )}
        </span>
      ),
    },
    {
      label: `${item && item.cate_id === 'receive' ? 'From' : 'To'}`,
      content: (
        <p style={{ fontWeight: '700' }} className="slds-truncate">
          {' '}
          {item && item.cate_id === 'receive' && item.receives
            ? item.receives.map((i) => (
                <>
                  {resolveAddress(i.from_addr).name ? resolveAddress(i.from_addr).name : 'Unknown'}
                </>
              ))
            : item && item.tx && resolveAddress(item.tx.to_addr).name
            ? item && resolveAddress(item.tx.to_addr).name
            : 'Unknown'}{' '}
        </p>
      ),
    },
    {
      label: 'Amount',
      content: (
        <span style={{ fontWeight: '700' }}>
          {item && getNumbersWithDecimalPlaces(item?.amount || 0)}
        </span>
      ),
    },
    {
      label: 'Chain',
      content: <span style={{ fontWeight: '700' }}>{item && item.chain && item.chain.name}</span>,
    },
    // {
    //   label: 'Account Before TX',
    //   content: <span style={{ fontWeight: '700' }}>10,325,453.34</span>,
    // },
    // {
    //   label: 'Account After TX',
    //   content: <span style={{ fontWeight: '700' }}>8,325,453.34</span>,
    // },
    // {
    //   label: 'Account Change',
    //   content: <span style={{ color: '#E16032', fontWeight: '700' }}>$2,325,453.34 (-2.45%)</span>,
    // },
  ];

  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <BrandBand id="brand-band-lightning-blue">
          <div className="pageContent">
            <PageHeader
              details={details}
              icon={
                <Icon
                  assistiveText={{ label: 'User' }}
                  category="standard"
                  name="catalog"
                  containerStyle={{ backgroundColor: '#48C3CC' }}
                />
              }
              label="Transaction"
              title={`${item ? item?.account : ''} - ${item ? item?.account_name : ''}`}
              variant="record-home"
              className="details-header"
            />
          </div>
          {/* ------------------------Chain-------------------------------------- */}
          <div
            style={{ display: 'flex', marginTop: '1.5rem', marginLeft: '4px', marginRight: '4px' }}
          >
            <div style={{ flexBasis: '60%' }} className="home_card_two">
              <div style={{ marginBottom: '1rem' }}>
                <span className="heading_text">Overview</span>
              </div>
              {item && <TransactionDetailsTab data={item} />}
            </div>
            <div style={{ flexBasis: '40%' }} className="home_card_two">
              <div style={{ marginBottom: '1rem' }}>
                <span className="heading_text">Notes</span>
              </div>
              <div style={{ padding: '0.8rem' }}>
                <Notes data={item?.note} transactionId={item?._id} tx_hash={id} />
              </div>
            </div>
          </div>
        </BrandBand>
      )}
    </>
  );
}
